export default __webpack_public_path__ + "static/media/technosf.089e7302.pdf";